import * as Yup from 'yup';

export const requestFormSchema = Yup.object().shape({
    name: Yup.string().required('Обязательное поле'),
    company: Yup.string().required('Обязательное поле'),
    phone: Yup.string().required('Обязательное поле'),
  });